import apiSlice from '../api/api.slice';
import { IReviewsResponse, IMyReview, ISubmitReviewRequest } from './review.d';

const reviewApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReviews: builder.query<IReviewsResponse, void>({
      query: () => ({ url: '/api/v1/reviews', method: 'GET' }),
      transformResponse: (response: {
        reviews: IReviewsResponse['reviews'];
        averageRating: number;
        total: number;
      }) => ({
        reviews: response.reviews,
        averageRating: response.averageRating,
        total: response.total,
      }),
    }),
    getMyReview: builder.query<IMyReview | null, void>({
      query: () => ({ url: '/api/v1/reviews/me', method: 'GET' }),
      transformResponse: (response: { review: IMyReview | null }) =>
        response.review,
    }),
    submitReview: builder.mutation<IMyReview, ISubmitReviewRequest>({
      query: (body) => ({ url: '/api/v1/reviews', method: 'POST', body }),
      transformResponse: (response: { review: IMyReview }) => response.review,
    }),
    deleteMyReview: builder.mutation<void, void>({
      query: () => ({ url: '/api/v1/reviews/me', method: 'DELETE' }),
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['Review', 'MyReview'],
  endpoints: {
    getReviews: { providesTags: ['Review'] },
    getMyReview: { providesTags: ['MyReview'] },
    submitReview: { invalidatesTags: ['Review', 'MyReview'] },
    deleteMyReview: { invalidatesTags: ['Review', 'MyReview'] },
  },
});

export const {
  useGetReviewsQuery,
  useGetMyReviewQuery,
  useSubmitReviewMutation,
  useDeleteMyReviewMutation,
} = reviewApiSlice;
